import { useMediaQuery, useTheme } from '@mui/material';
import { useState } from 'react';

export const useGetSidebarSize = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [isOpened, setIsOpened] = useState(true);

  const SIDEBAR_OPEN = 300;
  const SIDEBAR_CLOSED = 100;
  const sidebarWidth = isMobile
    ? isOpened
      ? SIDEBAR_OPEN
      : 0
    : isOpened
      ? SIDEBAR_OPEN
      : SIDEBAR_CLOSED;
  const mainContainerMargin = isMobile ? 0 : sidebarWidth;
  return { sidebarWidth, isOpened, setIsOpened, mainContainerMargin };
};
